<template>
  <b-modal size="xl" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
    <div class="modal-header d-flex justify-content-center pt-1">
      <h5 class="modal-title text-center">{{ empresaNome }}</h5>
    </div>
    <b-card bg-variant="light">
      <b-form @submit.prevent="load">
        <b-row>
          <b-col>
            <lg-form-const-select @change="load()" v-model="situacao" id="situacao" :options="optionsFilterSituacao"
              label="Situação:" />
          </b-col>

          <b-col>
            <lg-form-input id="searchText" label="Descrição:" v-model="searchText" />
          </b-col>
          <b-col class="ml-4 d-flex align-items-center">
            <b-button id="procurar" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
              @click="load">
              <div class="btn-size-alinhamento">
                <b-icon icon="search" />
              </div>
              <b-tooltip target="procurar" title="Localizar" triggers="hover focus"></b-tooltip>
            </b-button>
          </b-col>
          <b-col class="text-right d-flex justify-content-end align-items-center">
            <b-button v-if="temPrivilegioCadastro()" id="novo" class="ml-3 mr-2 my-2" style="height: 20px" size="sm" pill variant="secondary"
              @click="showModalAdicionar = true">
              <div class="btn-size-alinhamento">
                <b-icon scale="1" icon="plus" />
              </div>
              <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <b-card bg-variant="light">
      <b-table striped hover :items="this.records" :fields="campos" :busy="this.busy" show-empty>
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
        <template #empty>
          <p>Nenhum registro encontrado</p>
        </template>
        <template #cell(banco)="{ item }">
          <span class="px-2">{{ item.banco.nome }}</span>
        </template>
        <template #cell(agencia)="{ item }">
          <span class="px-2">{{ item.agencia }}</span>
        </template>
        <template #cell(conta)="{ item }">
          <span class="px-2">{{ item.numero }}</span>
        </template>
        <template #cell(acoes)="{ item }">
          <div class="d-flex align-items-center justify-content-end">
            <b-button :disabled="!temPrivilegioEdicao()" id="modificar" class="my-2" size="sm" pill variant="primary" @click="ModalEditar(item)">
              <b-icon icon="pencil-square" />
              <b-tooltip target="modificar" title="Editar..." triggers="hover"></b-tooltip>
            </b-button>

            <span class="mx-2">
              <b-button v-if="item.principal" variant="success" class="my-2 mx-2" size="sm"
                :id="'principal-icon-' + item.id">
                <b-icon icon="check-circle" />
              
                <b-tooltip :target="'principal-icon-' + item.id" title="Conta principal" triggers="hover"></b-tooltip>
              </b-button>
            </span>

            <b-form-checkbox :disabled="!temPrivilegioEdicao()" v-model="item.situacao" @change="alteraSituacao(item)" name="check-button" switch size="lg"
              :value="1" :unchecked-value="0" class="text-right" :id="'situacao-' + item.id" />
            <b-tooltip :target="'situacao-' + item.id" title="Alterar situação" triggers="hover"
              class="text-right"></b-tooltip>
          </div>
        </template>
      </b-table>

      <b-row style="margin-top: 12px" v-if="records && records.length > 0">
        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
          Página {{ page }} de {{ totalPage }} - {{ total }} registros
        </b-col>
        <b-col cols="6">
          <div class="d-flex justify-content-end align-items-end">
            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
              :total-rows="total"></b-pagination>
          </div>
        </b-col>
      </b-row>

    </b-card>
    <ModalContaBancariaAdicionar v-if="showModalAdicionar" :codEmpresa="codEmpresa" :prefix="updatedPrefix"
      @fechar="fechar" :id="idEdit"></ModalContaBancariaAdicionar>
  </b-modal>
</template>

<script>
import { ListResourceMixin } from "@/core/mixins/resource";
import ResourceService from "@/core/api/ResourceService";
import ConfirmMixin from "@/core/mixins/confirm";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import ModalContaBancariaAdicionar from "./ModalContaBancariaAdicionar.vue";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"

export default {
  components: {
    LgFormInput,
    LgFormConstSelect,
    ModalContaBancariaAdicionar,
  },
  props: {
    id: Number,
    prefix: Array,
    empresaNome: String,
    codEmpresa: Number,
  },
  data() {
    return {
      showModal: true,
      situacao: 1,
      searchText: "",
      showModalAdicionar: false,
      idEdit: null,
      campos: [
        { key: "banco", label: "Banco" },
        { key: "agencia", label: "Agência" },
        { key: "conta", label: "Conta" },
        { key: "acoes", label: "", tdClass: "text-right" },
      ],
      optionsFilterSituacao: [
        { key: "filterSituacao", text: "Todos", value: undefined },
        { key: "filterSituacao", text: "Ativo", value: "1" },
        { key: "filterSituacao", text: "Inativo", value: "0" },
      ],
    };
  },
  mixins: [ListResourceMixin, ConfirmMixin],
  beforeMount() {
    this.$service = new ResourceService(`/api/contabancaria`);
  },
  mounted() {
    this.load();
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Conta Bancária"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  watch: {
    page() {
      this.load()
    },
  },

  methods: {
    temPrivilegioCadastro() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_INCLUIR);

    },
    temPrivilegioEdicao() {
      return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);

    },

    async alteraSituacao(item) {
      let response = await this.$confirm(
        "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " a Conta Bancária?",
        item.numero
      )
      if (response) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao === 1 ? 0 : 1
      }
   },
    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$service.alteraSituacao(item);

      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${item.situacao ? "Ativado" : "Desativado"
            } com sucesso!`,
        });
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
            } o registro!`,
        });
      }
    },
    ModalEditar(item) {
      this.idEdit = item.id;
      this.showModalAdicionar = true;
    },
    async load() {
      this.busy = true;
      var filtro = {};
      if (this.codEmpresa) {
        filtro.codEmpresa = this.codEmpresa;
      }
      if (this.searchText) {
        filtro.pesquisaConta = this.searchText;
      }
      if (this.situacao != undefined) {
        filtro.situacao = this.situacao;
      }

      await this.$loadResource({
        limit: this.perPage,
        page: this.page,
        params: filtro,
      });
      this.busy = false;
    },
    fechar() {
      this.showModalAdicionar = false;
      this.idEdit = null;
      this.load();
    },
    cancelar() {
      this.$emit("close");
    },
  },
};
</script>
